import dynamic from 'next/dynamic'

// Shared dynamic-import wrapper so every consumer (currently the homepage,
// board pages, and highlight pages) stays in sync on loading/ssr options
// instead of each declaring its own next/dynamic() call independently.
//
// Deliberately no `ssr: false` -- SliderCover renders real, SEO-relevant
// hero content (and is often the LCP element), so it must stay
// server-rendered. Without ssr:false, react-slick's JS still code-splits
// into its own chunk instead of shipping in every page's main bundle.
export default dynamic(() => import('./index'))
